module.exports = __webpack_public_path__ + "static/media/budget-icon.9e2bbe5f.svg";